<template>
  <div class="admin-wrapper">
      <div class="columns">
        <div class="column is-12">
          <section class="hero is-info is-small">
            <div class="hero-body">
              <h1 class="title is-1">Business Health</h1>
              <h2 class="subtitle">Snapshot summary of key revenue metrics</h2>
            </div>
          </section><br><br>
          <!-- Video Creation Stats -->
          <section class="columns stats" v-loading="loading">
            <div class="column">
              <el-card class="box-card">
                <p class="title">{{metrics.mrr | toUSD}}</p>
                <p class="subtitle">Monthly Revenue</p>
              </el-card>
            </div>
            <div class="column">
              <el-card class="box-card">
                <p class="title">{{metrics.arr | toUSD}}</p>
                <p class="subtitle">Annual Revenue</p>
              </el-card>
            </div>
            <div class="column">
              <el-card class="box-card">
                <p class="title">{{metrics.mrr_growth_rate | toPercent}}</p>
                <p class="subtitle">Growth</p>
              </el-card>
            </div>
            <div class="column">
              <el-card class="box-card">
                <p class="title">{{metrics.revenue_churn | toPercent}}</p>
                <p class="subtitle">Revenue Churn</p>
              </el-card>
            </div>
          </section><br>
          <section class="columns stats">
            <div class="column">
              <el-card class="box-card">
                <p class="title">{{metrics.active_subscriptions.toLocaleString()}}</p>
                <p class="subtitle">Total Customers</p>
              </el-card>
            </div>
            <div class="column">
              <el-card class="box-card">
                <p class="title">+{{metrics.new_customers}}</p>
                <p class="subtitle">Customers (24 hr)</p>
              </el-card>
            </div>
            <div class="column">
              <el-card class="box-card">
                <p class="title">{{metrics.ltv | toUSD}}</p>
                <p class="subtitle">Lifetime Value</p>
              </el-card>
            </div>
            <div class="column">
              <el-card class="box-card">
                <p class="title">{{metrics.failed_charges}}</p>
                <p class="subtitle">Failed Charges</p>
              </el-card>
            </div>
          </section>
        </div>
      </div>
  </div>
</template>

<script>
import Reports from '@/api/report.service';
import '@/style/admin.scss';

export default {
  name: 'reports',
  data() {
    return {
      loading: true,
      stats: {
        jobCount: 0,
        pendingJobs: [],
        completedJobs: [],
        newUsers: [],
        pausedUsers: [],
        canceledUsers: [],
        reactivatingUsers: [],
      },
      metrics: {
        mrr: 0,
        arr: 0,
        ltv: 0,
        mrr_growth_rate: 0,
        active_subscriptions: 0,
        revenue_churn: 0
      },
      me: this.$store.state.user
    }
  },
  filters: {
    toUSD(val) {
      const dollarValue = parseInt(val) / 100;
      return `$${dollarValue.toLocaleString()}`;
    },
    toPercent(val) {
      return `${parseInt(val) / 100}%`;
    },
  },
  created() {
    this.getMetrics();
    this.getStats();
  },
  methods: {
    async getMetrics() {
      const { metrics } = await Reports.getMetrics();
      this.metrics = metrics[0];
      this.loading = false;
    },

    async getStats() {
      this.stats.jobCount = (await Reports.getJobStats()).count;
      this.stats.pendingJobs = await Reports.getPendingJobs();
      this.stats.completedJobs = await Reports.getCompleteJobs();
      this.stats.newUsers = await Reports.getNewUsers();
      this.stats.pausedUsers = await Reports.getPausedUsers();
      this.stats.canceledUsers = await Reports.getCanceledUsers();
      this.stats.reactivatingUsers = await Reports.getReactivations();
    }

  }
}
</script>
